import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";
import {
  deleteBusinessHours,
  selectBusinessHoursList,
} from "../../../store/slices/projectSlice";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function BusinessHoursList() {
  const params = useParams();
  const businessHoursList = useSelector(selectBusinessHoursList);
  const dispatch = useDispatch();

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2 d-flex align-items-start">
        <h5 className="card-title">Business hours</h5>
        <HelpButton helpKey="components-business-hours" />
        <div className="flex-grow-1" />
        <Link
          to={`/library/logic/builder/${params.projectID}/business-hours/create_new`}
          className="btn btn-outline-primary btn-sm border-0"
        >
          <FontAwesomeIcon icon={faPlus} />
        </Link>
      </div>
      <div className="card-body p-0">
        {businessHoursList.length > 0 ? (
          <ul className="list-group list-group-flush">
            {businessHoursList.map((businessHours) => (
              <li
                key={businessHours.UUID}
                className="list-group-item p-2 d-flex justify-content-between align-items-center"
              >
                <Link
                  to={`/library/logic/builder/${params.projectID}/business-hours/${businessHours.UUID}`}
                >
                  <span>
                    {businessHours.Label || businessHours.UUID.slice(0, 5)}
                  </span>
                </Link>

                <UsedInBadge
                  arg={businessHours}
                  alt={
                    // eslint-disable-next-line jsx-a11y/control-has-associated-label
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm border-0"
                      onClick={() => {
                        dispatch(deleteBusinessHours(businessHours.UUID));
                        toast.success("Business hours deleted");
                      }}
                      title="Delete business hours"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </button>
                  }
                />
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center m-1">No business hours</div>
        )}
      </div>
    </div>
  );
}
